import { Container } from "react-bootstrap";
import { portalStore } from "../../../../Stores/portal";
import { useRef, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { observer } from "mobx-react";
import { accountingStore } from "../../../../Stores/acountingStore";

export const _Pricings: React.FC = () => {
  const headerRef = useRef(null);

  return (
    <Container
      fluid
      style={{
        display: "flex",
        flexFlow: "column",
        maxHeight: portalStore.portalHeight,
      }}
    >
      <div ref={headerRef}>
        <h1 style={{ fontWeight: "bolder" }}>Our Pricing models</h1>
        <label>
          These are the pricing models the store should use when allocating
          transactions.
        </label>
      </div>
      <TableContainer sx={{ maxHeight: 440 }}>
        {" "}
        {/* Added maxHeight for scrollability if many rows */}
        <Table stickyHeader aria-label="paginated table">
          <TableHead>
            <TableRow>
              <TableCell>ID (UNIQUE)</TableCell>
              <TableCell align="left">Description</TableCell>
              <TableCell align="right">Value/Cost (ZA)</TableCell>
              <TableCell align="right">VAT Constant</TableCell>
              <TableCell align="left">Store</TableCell>
              <TableCell align="left">Timestamp (Creation)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {accountingStore.pricingModels.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell component="th" scope="row">
                  {row.description}
                </TableCell>
                <TableCell align="right">{row.value}</TableCell>
                <TableCell align="right">
                  ZAR {(row.value * row.vat).toFixed(2)}{" "}
                  <span style={{ color: "gray" }}>
                    ({(row.vat * 100.0).toFixed(2)}
                    {"%"})
                  </span>
                </TableCell>
                <TableCell align="left">{row.storeId}</TableCell>
                <TableCell align="left">
                  {row.createdOn
                    .replace("T", " ")
                    .substring(0, row.createdOn.lastIndexOf("."))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]} // Options for the "Rows per page" dropdown
        component="div" // Can be a div, Paper, etc.
        count={0} // Total number of rows in your dataset
        rowsPerPage={0} // Current number of rows per page
        page={1} // Current page number
        onPageChange={handleChangePage} // Callback when page changes
        onRowsPerPageChange={handleChangeRowsPerPage} // Callback when rows per page changes
      /> */}
    </Container>
  );
};

export const Pricings = observer(_Pricings);
